<template>
  <div class="markerDataTable" v-if="layerData && layerData.type !== 'FOLDER' && visible " :shared="shared">
    <SppucDataTable :layerData="layerData" v-if="layerData.module === 'sppuc'" ref="sppucTable"
      @closeMarkerTable="close"
      @updateMarkerTable="(data)=>{emit('updateMarkerTable', data)}"
      @editMarker="(data)=>{emit('editMarker',data)}"
      @refresh="(data)=>{emit('refresh',data)}"
      @showImportMarker="(data)=>{emit('showImportMarker',data)}"
      @detailSppucMarker="onDetailSppucMarker">
    </SppucDataTable>
    <ApiDataTable :layerData="layerData" v-else-if="layerData.dataSourceType === 'API'" ref="apiDataTable"
      @closeMarkerTable="close"
      @updateMarkerTable="(data)=>{emit('updateMarkerTable', data)}"
      @editMarker="(data)=>{emit('editMarker',data)}"
      @refresh="(data)=>{emit('refresh',data)}"
      @detailApiMarker="onDetailApiMarker">
    </ApiDataTable>
    <MakerTable :layerData="layerData" v-else ref="makerTable"
      @closeMarkerTable="close"
      @updateMarkerTable="(data)=>{emit('updateMarkerTable', data)}"
      @editMarker="(data)=>{emit('editMarker',data)}"
      @refresh="(data)=>{emit('refresh',data)}"
      @detailMarker="detailMarker">
    </MakerTable>
  </div>
</template>

<script>
import MakerTable from './MakerTable'
import ApiDataTable from './ApiDataTable'
import SppucDataTable from './sppuc/SppucDataTable'
import { mapGetters } from 'vuex'
export default {
  name: 'MarkerDataTable',
  props: {
    layerData: {
      type: Object,
      default: null
    }
  },
  inject: ['shared'],
  data: function () {
    return {
      isShow: false
    }
  },
  components: {
    MakerTable,
    ApiDataTable,
    SppucDataTable
  },
  computed: {
    ...mapGetters(['spaceSearchJeojson']),
    visible () {
      return this.isShow && !this.spaceSearchJeojson
    }
  },
  methods: {
    open () {
      this.isShow = true
    },
    close () {
      this.$emit('updateMarkerTable')
      this.isShow = false
    },
    emit (msg, data) {
      this.$emit(msg, data)
    },
    detailMarker (data) {
      this.$emit('detailMarker', data)
      // this.close()
    },
    onDetailApiMarker (data) {
      this.$emit('detailApiMarker', data)
      // this.close()
    },
    onDetailSppucMarker (data) {
      this.$emit('detailSppucMarker', data)
    },
    refreshTableData () {
      if (!this.isShow || !this.layerData) {
        return
      }
      if (this.layerData.dataSourceType !== 'API' && this.$refs.makerTable) {
        this.$refs.makerTable.refreshTableData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.markerDataTable{
  width: 100%;
  height: 100%;
}
</style>
